import React, { useState, useEffect } from 'react';
import Badge from '@material-ui/core/Badge';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';

import CommonContainer from "../../containers/Common";
import { makeStyles, Theme, createStyles, IconButton, Popover, withStyles } from '@material-ui/core';
import { Status, StockOrderStatusEnum, GetErrorListRequest } from 'openapi';
import ErrorList from '../lists/ErrorList';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        typography: {
            padding: theme.spacing(2),
        },
        notificationIcon: {
            marginRight: '5px',
            color: 'lightgray',
            fontSize: '30px'
        }
    }),
);

const StyledBadge = withStyles((theme: Theme) =>
    createStyles({
        badge: {
            right: 5,
            top: 3,
            border: `2px solid ${theme.palette.background.paper}`,
            padding: '0 4px',
        },
    }),
)(Badge);

export default (() => {

    const commonContainer = CommonContainer.useContainer();

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [errorList, setErrorList] = useState<Status[]>([]);
    const [errorListLength, setErrorListLength] = useState(0);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        (async () => {
            // get status List
            var errorList = await commonContainer.getStatusList(StockOrderStatusEnum.Error);
            setErrorList(errorList ? errorList : []);
            setErrorListLength(errorList ? errorList.length : 0);
        })();
    }, []);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = async () => {
        setAnchorEl(null);
        setErrorListLength(0);

        var orderErrorList = {
            errorChecked: {
                ids: []
            }
        };
        var ids: any = [];

        errorList.map(error => {
            ids.push({ requestId: error.orderRequestId, orderType: error.orderType });
        })

        orderErrorList.errorChecked.ids = ids;
        // Change IsErrorChecked to 1
        await commonContainer.updateErrorListChecked(orderErrorList);
    };

    return (
        <>
            <IconButton aria-label="cart" onClick={handleClick}>
                <StyledBadge badgeContent={errorListLength} color="secondary">
                    <NotificationImportantIcon className={classes.notificationIcon} />
                </StyledBadge>
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <ErrorList errorList={errorList} />
            </Popover>
        </>
    );
}) as React.FC;
